<template>
	<div class="lightgray-content border mb-2 mt-2 rounded p-4">
		<slot name="header" :slot_provider="organization_data">
      <!-- <div class="status_container margin-status-50">
          <provider-status-action
            :key="organization.id"
            :user_status="organization_data.status_id"
            :provider="organization"

          />
        </div> -->
    </slot>

		<div v-if="show_details">
			<form @submit.prevent="onSubmit" v-if="show_organization_details">
				<div class="row">
					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label>First name</label>
							<input placeholder="First name" type="text"  class="form-control" name="first_name"
								v-model="organization_data.first_name" :disabled=" !organization.is_active ? true : false ">
							<span class="input-error-msg">{{ errors.first('first_name') }}</span>
						</div>
					</div><!--col-->
					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label>Last name</label>
							<input placeholder="Last name" type="text"  class="form-control" name="last_name"
								v-model="organization_data.last_name" :disabled=" !organization.is_active ? true : false ">
							<span class="input-error-msg">{{ errors.first('last_name') }}</span>
						</div>
					</div><!--col-->


					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<phone-country-code
							:rule="'not_required'"
							:section="'existin-provider'"
							:country_codes="country_codes"
							:form="organization_data"
							@countryInput="countryInput"/>
							<!-- <label>Country code</label>
							<v-select name="country_code" :searchable="true" :options="country_codes" v-model="organization_data.country_code"
									v-validate="'required'" :disabled=" !organization.is_active ? true : false ">
							</v-select>
							<span class="input-error-msg">{{ errors.first('country_code') }}</span> -->
						</div>
					</div><!--col-->

					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label>Cell phone number</label>
							<input placeholder="Cell phone number" type="text"  class="form-control" name="phone" v-validate="'min:8|max:10'"
								v-model="organization_data.phone" :disabled=" !organization.is_active ? true : false ">
							<span class="input-error-msg">{{ errors.first('phone') }}</span>
						</div>
					</div><!--col-->

					<!--
					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label>Email</label>
							<input placeholder="Email" type="text"  class="form-control" name="email"
								v-model="organization_data.email" :disabled=" !organization.is_active ? true : false ">
							<span class="input-error-msg">{{ errors.first('first_name') }}</span>
						</div>
					</div>
				-->
				</div><!--row-->
				<div class="row">
					<!-- 	<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label id="tooltip-approving-completion">RN approving completion</label>

							<v-select class="mb-2"  name="approving_completion" :searchable="true"  track-by="id" label="str"  :disabled=" !organization.is_active ? true : false "
								v-model="organization_data.manager_approving_the_hha_score" :options="approving_completions" 		v-validate="$props['subrole_config']['2']['mandatory'] == 1 ? 'required' : ''">
							</v-select>

							<span class="input-error-msg">{{ errors.first('approving_completion') }}</span>

								<span class="input-error-msg"
									v-if="organization_data.manager_approving_the_hha_score != null && (organization_data.manager_approving_the_hha_score == organization_data.lhcsa_manager
											|| organization_data.manager_approving_the_hha_score == organization_data.coordinator
											|| organization_data.manager_approving_the_hha_score == organization_data.supporting_rn) && !errors.has('approving_completion')">
									You can't repeat this email
								</span>
						</div>
					</div> -->

				<!--	<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label id="tooltip-supporting-rn">Learner support</label>

							<b-tooltip target="tooltip-supporting-rn" triggers="hover">
								<div class="tooltip-subrole">
									Learner Support-Choose the individual who will be replying to learner's questions about the training (we highly suggest you choose Nevvon).
							    </div>
						   </b-tooltip>

							<v-select class="mb-2"  name="supporting_rn" :searchable="true"  track-by="id" label="str"  :disabled=" !organization.is_active ? true : false "
							v-model="organization_data.supporting_rn" :options="supporting_rn" v-validate="$props['subrole_config']['3']['mandatory'] == 1 ? 'required' : ''">
								</v-select>

							<span class="input-error-msg">{{ errors.first('supporting_rn') }}</span>

							<span class="input-error-msg"
								v-if="organization_data.supporting_rn != null && (organization_data.supporting_rn == organization_data.lhcsa_manager
										|| organization_data.supporting_rn == organization_data.coordinator
										|| organization_data.supporting_rn == organization_data.manager_approving_the_hha_score) && !errors.has('supporting_rn')">
								You can't repeat this email
							</span>

						</div>
					</div> -->

				<!--	<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label id="tooltip-coordinator">Coordinator</label>

							<b-tooltip target="tooltip-coordinator" triggers="hover">
								<div class="tooltip-subrole">
							    	Choose the individual who will keep track of the learner's progress daily. This individual will be the most active in the platform.
							    </div>
						   </b-tooltip>

							<v-select class="mb-2" name="coordinator" :searchable="true"  track-by="id" label="str"  :disabled=" !organization.is_active ? true : false "
									v-model="organization_data.coordinator" :options="coordinators" 		v-validate="$props['subrole_config']['0']['mandatory'] == 1 ? 'required' : ''">
								</v-select>


							<span class="input-error-msg">{{ errors.first('coordinator') }}</span>
							<span class="input-error-msg"
									v-if="organization_data.coordinator != null && (organization_data.coordinator == organization_data.lhcsa_manager
											|| organization_data.coordinator == organization_data.manager_approving_the_hha_score
											|| organization_data.coordinator == organization_data.supporting_rn) && !errors.has('coordinator')">
									You can't repeat this email
								</span>
						</div>
					</div> -->


					<!-- <div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label id="tooltip-agency-manager">Agency manager</label>

							<b-tooltip target="tooltip-agency-manager" triggers="hover">
								<div class="tooltip-subrole">
							    	This individual is typically a high-level manager who can view progress but does not check every day.
							    </div>
						   </b-tooltip>

							<v-select class="mb-2" name="lhcsa_manager" :searchable="true"  track-by="id" label="str"  :disabled=" !organization.is_active ? true : false "
							v-validate="$props['subrole_config']['1']['mandatory'] == 1 ? 'required' : ''"
									v-model="organization_data.lhcsa_manager" :options="managers">
								</v-select>


							<span class="input-error-msg">{{ errors.first('lhcsa_manager') }}</span>

							<span class="input-error-msg"
								v-if="organization_data.lhcsa_manager != null && (organization_data.lhcsa_manager == organization_data.coordinator
										|| organization_data.lhcsa_manager == organization_data.manager_approving_the_hha_score
										|| organization_data.lhcsa_manager == organization_data.supporting_rn) && !errors.has('lhcsa_manager')">
								You can't repeat this email
							</span>

						</div>
					</div> -->
				</div><!--row-->
				<div class="row">
					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label>Employment date</label>
							<div class="row ml-0">
								<date-picker class="date_picker_new" v-model="organization_data.onboard_date"  :range="false" :format="'MM-DD-YYYY'"
								:placeholder="'Employment date'"
								:disabled=" !organization.is_active ? true : false "
								:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
								:valueType="'YYYY-MM-DD'"></date-picker>
							</div>
						</div>
					</div><!--col-->
					<div class="col-12 col-md-6 col-xl-3">
						<div class="form-group input-content">
							<label>Employee number</label>
							<input placeholder="Employee number" type="text"  class="form-control" name="employer_number"
								v-model="organization_data.employer_number"  :disabled=" !organization.is_active ? true : false ">
							<span class="input-error-msg">{{ errors.first('employer_number') }}</span>
						</div>
					</div><!--col-->

					<div class="col-12 col-md-6 col-xl-3" v-if="organization != null">
						<div class="input-content">
							<label>Discipline<template v-if="$props['organization']['discipline_mandatory'] == 1">*</template></label>

							<v-select class="mb-2 v-select-no-height discipline" multiple :searchable="true"  track-by="id" label="name" name="organization_discipline_id" allowClear="true"
										:value="discipline_array" :options="disciplines" v-validate="$props['organization']['discipline_mandatory'] == 1 ? 'required' : '' "  :disabled=" !organization.is_active ? true : false ">


							</v-select>
							<span class="input-error-msg">{{ errors.first('organization_discipline_id') }}</span>
						</div>
					</div>
					<div class="col-12 col-md-6 col-xl-3" v-if="organization != null">
						
							<div class="mt-3 d-flex align-item-center">
								<label class="applicant-checkbox">
									<input type="checkbox" v-model="organization_data.is_applicant"/>
									<span></span>
								</label>

								<span class="ml-1" style="width:auto; font-size: 14px; font-weight: bold;">Is Applicant</span>	
							</div>
						
            		</div>
				</div><!--row-->

				<sub-location-selection v-if="organization != null && locations_loaded && organization_data
				&& temp_location_information != ''"
					:mandatory="$props['organization']['location_mandatory']"
					:locations="locations"
					:selected_location="temp_location_information"
					:organization="organization"
					@locationChanged="locationChanged"
					 >
				</sub-location-selection>
        <div class="row ml-0" v-if="show_shift_blocking">
         <shift-blocking-view :provider_data="organization_data" :organization_id="organization.id" />
        </div>
				<div class="row" >
					<div class="col-12 text-right">
						<button v-if="user_meta_actions.includes('edit_provider_details_including_roles')" type="submit" class="button green-content large-button white"  :disabled=" !organization.is_active ? true : false "
							:class="{ 'button-disabled' : !organization.is_active }">
							Update
						</button>
					</div>
				</div>
			</form>
			<div class=" mt-4 d-flex">
				<h5 class="bold green">PROGRAMS</h5>
				<add-provider-to-course class="ml-2"
					:class="{'input-disabled':disabledToggleByStatus()}"
					:provider="provider"
					@providerAdded="getInfo"
					:organization="organization">
					<template slot="text-button">
						<img class="mr-1" src="../../assets/images/icons/solid/plus_white.svg" width="12"/>
						Add
					</template>
				</add-provider-to-course>
			</div>
			<div class="d-flex align-items-center" v-for="(course, index) in courses">
				<div>
					<div class="h1 mr-3 count-number">{{ index+1 }}</div>
				</div>
				<div :class="{'not-allowed': course.published == 0}" 
				class="white-content flex-fill border mb-2 rounded mt-2 pt-3 pr-3 pl-3 pb-0">
					<div class="row">
						<div class="col-12 col-md-6 col-xl-3">
							<div class="form-group input-content">
								<label>Program Name</label>
								<p>{{ course.name }}</p>
								<!-- <input placeholder="Program Name" type="text"  class="form-control" v-validate="'required'" name="asd">-->
								<span class="input-error-msg"></span>
							</div>
							<div v-if="course.published == 0" class="program-block-textarea">
								<p>Program Not Operational</p>
							</div>
						</div><!--col-->
						<!-- <div class="col-12 col-md-6 col-xl-2">
							<div class="form-group input-content">
								<label>Start date</label>
								<p>{{ course.starting_date }}</p>

								<span class="input-error-msg"></span>
							</div>
						</div> -->
						<div  class="width-220 mr-3">
							<!-- <div :class="{'not-allowed': !course.is_active}" class="form-group input-content due-date-not-expired" > -->
							<div :class="start_date_status_css(course)">
								<label>Start date</label>
								<date-picker class="date_picker_new mb-1"  v-model="course.starting_date" :range="false" :format="'MM-DD-YYYY'"
								:placeholder="'Start Date'"
								:disabled="(!organization.is_active ? true : false) || !user_meta_actions.includes('edit_provider_start_date')"
								:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
								:valueType="'YYYY-MM-DD'">
								</date-picker>
								 <button v-if="user_meta_actions.includes('edit_provider_start_date')" :class="{ 'input-disabled': course.starting_date == null || organization.is_active == 0}" :disabled="course.starting_date == null || organization.is_active == 0" class="button m.b-0" @click="UpdateDate(course)">Update</button>
								 <span class="input-error-msg"></span>
							</div>
						</div><!--col-->
						<div class="width-220">
							<div :class="due_date_status_css(course)" >
								<label>Due date</label>
								<date-picker 
									class="date_picker_new mb-1"
									v-model="course.due_date" :range="false"
									:format="'MM-DD-YYYY'"
									:placeholder="'Due Date'"
									:disabled="providerCanEditDueDate()|| !user_meta_actions.includes('edit_provider_due_date')"
									:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
									:valueType="'YYYY-MM-DD'">
								</date-picker>
								<button
									v-if="user_meta_actions.includes('edit_provider_due_date')"
									:class="{ 'input-disabled': course.due_date == null || providerCanEditDueDate()}"
									:disabled="course.due_date == null || providerCanEditDueDate()"
									class="button m.b-0" @click="UpdateDate(course)">
									Update
								</button>
								<span class="input-error-msg"></span>
							</div>
						</div><!--col-->
						<div class="col-12 col-md-6 col-xl-2">
							<div class="pt-2 pb-2 mb-0 d-sm-flex justify-content-between align-items-center">
				        		<div class="completion-bar completion-bar-xs">
					        		<div v-bind:style="{ width: course.completion + '%' }"></div>
					        		<span>{{ course.completion }}%</span>
				        		</div>
			        		</div>
						</div>
						<div class="col-6 col-md-4 col-xl-2 negative-five-margin-top">
							<div class="input-group align-items-center space-around-flex">
							<div class="progress-icon info" @click="goToRouter(course)">
												<!-- <i class="fa fa-info button" ></i> -->
							</div>
							<div v-if="user_meta_actions.includes('approve_completion') && !show_remove_button(course) && course.status != 'in-progress'" class="progress-icon" 
							:class="{'awaiting button': course.status_str=='awaiting', [course.status_str] : course.status_str != 'awaiting'}"  @click="approveProviderCourse(course,index)" >

                      			<label v-if="course.status_str=='awaiting' && can_approve && user_meta_actions.includes('approve_completion')" class="approve-awaiting-text"> 
									Approve
								</label>

							</div>
							<div v-else :class="[course.status_str]" class="progress-icon"></div>
							<div v-if="course.status_str == 'approved'" class="ml-0 progress-icon download" @click="downloadCert(course.certificate_url)"></div>

									<toggle-button v-model="course.is_active ? true : false" class="mt-1"
										:labels="false" :width="50"
										:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
										@change="toggleCourseStatus(course)"
										:disabled="disabledToggleByStatus()"
										v-if="user_meta_actions.includes('deactivate_activate_provider_from_a_program')"
									/>

									<button
										v-if="(course.completion < 100) && user_meta_actions.includes('fake_complete_actions')"
										class="button"
										@click="simulateCompletion(course)"
									>
										Simulate Completion
									</button>
									
                   <div @click="showRemoveModal(course)" v-if="show_remove_button(course)"  class="progress-icon cursor-pointer">
                     	<i class="fa fa-trash fa-ninja-red font-30"></i>
                  </div>
                  <!-- <a @click="showRemoveModal()" v-if="show_remove_button(course)" class="mr-2">
                    	<i style="background-color: red; border: red;" class="fa fa-trash button red"></i> <small class="ml-1"></small>
                  </a> -->

							</div>
							<!-- <div class="row" v-if="course.status_str=='awaiting' && can_approve">
								<div class="input-group align-items-center">
									<div></div>
									<div v-if="user_meta_actions.includes('approve_completion')"><p class="approve-text due-date-not-expired margin-top-negative-5">Approve</p></div>

								</div>
							</div> -->

						</div>
					</div><!--row-->
				</div><!--white_content-->
			</div>
		</div>
    	<b-modal v-model="show_remove_modal" title="Remove employees from program" ok-title="Remove" @ok="removeProgramPermanently">
			<template>

				<p class="text-center">{{provider.first_name}} will be removed from the program. <br>This action cannot be undone</p>

			</template>
		</b-modal>
	</div><!--gray_content-->
</template>

<style scoped>
label.applicant-checkbox {
	position: relative;
}
label.applicant-checkbox span {
	width: 16px;
	height: 16px;
	border: 1px solid #11a5a7;
	display: inline-block;
	border-radius: 30%;
	transition: all linear 0.3s;
}
label.applicant-checkbox span:after {
	content: "";
	position: absolute;
	top: 2px;
	left: 6px;
	border-bottom: 2px solid #fff;
	border-right: 2px solid #fff;
	height: 9px;
	width: 4px;
	transform: rotate(45deg);
	visibility: hidden;
}
label.applicant-checkbox input {
	display: none;
}
label.applicant-checkbox input:checked ~ span {
	background: #11a5a7;
}
label.applicant-checkbox input:checked ~ span:after {
	visibility: visible;
}

</style>

<script>
import SubLocationSelection from './inputs/SubLocationSelection.vue'
import PhoneCountryCode from './inputs/PhoneCountryCode'
import ProvidersMixin from './ProvidersMixin'
import DatePickerView from './inputs/DatePickerView.vue'
import ProviderStatusAction from './inputs/ProviderStatusAction.vue';
import { EventBus } from '../../event_bus.js';
import ShiftBlockingView from './inputs/ShiftBlockingView.vue'
import DatePickerMixin from './inputs/DatePickerMixin'
	export default{
		mixins: [ProvidersMixin],
		props : {
			provider : {
				type : Object, //the object with the fields
				required : true
			},
			organization : {
				type : Object,
				required : true
			},
			organization_index : {

			},
			show_organization_details : {

			},
			subrole_config:{
				required : false
			},
			country_codes:{
				required : true
			}
		},
		components : {
			PhoneCountryCode,
			SubLocationSelection,
			DatePickerView,
      ProviderStatusAction,
      ShiftBlockingView
		},
		data : function(){
			return {
				router_name:'',
				user_role:'',
				courses : [],
				organization_data : {
					first_name : '',
		            last_name : '',
		            employer_number : '',
		            hha_registry_number : '',
		            phone : '',
		            onboard_date : null,
		            lhcsa_manager : '',
		            coordinator : '',
		            manager_approving_the_hha_score : '',
		            supporting_rn : '',
		            country_code : {

		            },
					current_location:'',
					is_applicant: true
					
				},
				show_details : true,
				subroles : [],
				approving_completions : [],
				supporting_rn : [],
				coordinators : [],
				managers : [],
				is_admin : false,
				red : this.config.COLORS.RED,
				green : this.config.COLORS.GREEN,
				is_suspended : false,
				disciplines : [],
				locations : [],
				discipline_mandatory : '',
				location_mandatory : '',
				show_form_errors : false,
				//country_codes : [],
				user_meta_actions:localStorage.getItem('meta_actions'),
				temp_location_information:'',
				locations_loaded: false,
        show_remove_modal: false,
        course_to_remove:null
			}
		},
    mounted: function(){
      EventBus.$on('getInfo', (e)=>{
        this.getInfo()
      })
    },
		watch: {
			'organization_data.phone': function(val){
				if(val != '' || val != null){
					var removedText = val.replace(/\D+/g, '');
					this.organization_data.phone = removedText
				}
			}
		},
		computed : {
        show_shift_blocking(){
          if(this.organization_data){
            if(this.organization_data.hasOwnProperty('shift_blocking_disabled')){
              return true
            }else{
              return false
            }
          }
        },
			// Put Disciplines to v-model and set name to show
			discipline_array: function(){
				var keys = []
				let val = this.organization_data.disciplines
				for(let i in val){
					if(val[i].name != null){
						// if(!keys.some(key=>key.id === val[i].id)){
							keys.push({name: val[i].name, id:val[i].id})
						// }
					}
				}
				return keys
			},
			can_approve: function(){
				if(this.user_role == 'organization' || this.user_role == 'admin' || this.user_role == 'csm'){
					return true
				}else{
					return false
				}
			}

		},
		created : function(){
			this.user_role = this.$store.getters.getRole
			this.getInfo();
			// this.organization_data = this.provider
			this.is_admin = this.$store.getters.getUser.is_admin;
			this.getDisciplines();
			this.getLocations();
			//this.getCountries();
		},

		methods : {
      providerCanEditDueDate(){
        //if on hold and active can edit
        if (this.organization_data.provider_status_id == 2 || this.organization_data.provider_status_id == 1
			|| this.provider.provider_status_id == 2 || this.provider.provider_status_id == 1) {
          return false
        } else {
          return true
        }
      },
      initRemoveModal(){
        this.course_to_remove = null

      },
      showRemoveModal(course){
        this.course_to_remove = course
        this.show_remove_modal = true
      },
      show_remove_button(course){
        //if not active and no progress - show the remove button
        if(!course.is_active && course.completion === '0.0'){
          return true
        }else{
          return false
        }
      },
      removeProgramPermanently: function(){
			  var params = {
					id: this.course_to_remove.id,
          filters:{
            provider_id: [this.provider.id],
				  	organization_id: this.organization.id
          }
				}
        this.$store.dispatch('deleteProviderFromCourse', params).then((res) => {
          this.initRemoveModal()
          if(this.user_role == 'organization'){
            this.$emit('getInfo')
          }else{
            this.getInfo()
          }
        this.$forceUpdate();
				}).catch((error) => {
					console.log(error);
				});

      },
      disabledToggleByStatus(){
        if(this.user_role == 'organization'){
           if(this.provider && this.provider.provider_status_id == 3){
            return true
          }
        }else{
          if(this.organization_data && this.organization_data.provider_status_id == 3){
            return true
          }
        }
        return false
      },
			due_date_status_css(course){
				if(!course.is_active || this.provider.provider_status_id === 3 || this.provider.provider_status_id === 2 ){
					return 'not-allowed form-group input-content input-content due-date-not-expired'
				}
				else if(course.due_date_expired ){
					return 'form-group input-content due-date-expired bold'
				}else{
					return 'form-group input-content due-date-not-expired'
				}
			},
			start_date_status_css(course){
				var current_date = new Date().toISOString().slice(0, 10);
				if(!course.is_active){
					return 'not-allowed form-group input-content input-content due-date-not-expired'
				}
				else if(course.starting_date !=null && course.starting_date.slice(0,10) > current_date ){
					return 'form-group input-content start-date-not-ready bold'
				}else{
					return 'form-group input-content due-date-not-expired'
				}
			},
			locationChanged: function(val){
				if(val){
					this.organization_data.organization_location_id = val
				}
			},
			approveProviderCourse: function(course,index){
				var params = {
					id:course.id,
					provider_id: this.provider.id,
					organization_id: this.organization.id
				}

				this.$store.dispatch('markCourseAsCompleted', params).then((res) => {
					this.getInfo();
					this.courses[index].status_str = 'approved'

				}).catch((error) => {
					console.log(error);
				});

			},
			goToRouter:function(course){
				if(this.is_admin){
					this.router_name = 'admin.providers.organization.course';
					this.$router.push({name:this.router_name,params : { id : this.provider.id, course_id : course.id, organization_id : this.organization.id } })
				}else if(this.user_role === 'csm'){
					this.router_name = this.user_role+'.courses.providers.detail';
					this.$router.push({name:this.router_name,params : { id : course.id, provider_id : this.provider.id}, query:{ agency_id : this.organization.id} })
				}else if(this.user_role != 'csm' && (!this.is_admin)){
					this.router_name = 'organization.courses.providers.detail'
					this.$router.push({name:this.router_name,params : { id : course.id, provider_id : this.provider.id} })
				}

			},
			countryInput: function(val){
				this.organization_data.country_code = val
			},
			getParams: function(course){
				if(this.user_role != 'csm' && this.user_role != 'admin'){
					var params = {
						id: this.provider.id,
						organization_id : this.provider.organization.id,
						course_id : course.id,
					}
					return params
				}else{
					var params = {
						id: this.provider.id,
						organization_id : this.organization.id,
						course_id : course.id,
					}
					return params
				}
			},
			UpdateDate: async function(course){
				//add a simple date check
				if(!course.starting_date){
						this.$snotify.warning('Starting Date is Required', {
						timeout: 2000,
						showProgressBar: true,
						closeOnClick: false,
						pauseOnHover: true
					});
					return
				}
				if(course.due_date.slice(0, 10) < course.starting_date.slice(0, 10)){
					this.$snotify.warning('Due date can’t be earlier than Start date', {
						timeout: 2000,
						showProgressBar: true,
						closeOnClick: false,
						pauseOnHover: true
					});
					return
				}
				var params = await this.getParams(course)
				params.filters = {
					due_date: course.due_date.slice(0, 10),
					starting_date: course.starting_date.slice(0, 10)
				}
				this.$store.dispatch('updateCourseDueDate', params).then((res) => {
					var current_date = new Date().toISOString().slice(0, 10);
					if(course.due_date.slice(0,10) > current_date){
						course.due_date_expired = 0
					}else{
						course.due_date_expired = 1
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			getInfo : function(){
				if(this.user_role === 'csm' || this.user_role === 'admin'){
					var params = {
						id : this.provider.id,
						filters : {
							organization_id : this.organization.id,
							include_expired : 1
						}
					}

					this.$store.dispatch('getProviderOrganizationDetail', params).then((res) => {

						this.organization_data = res.data.data;
						this.temp_location_information = res.data.data.organization_location_id
						if(this.organization_data.onboard_date == '-0001-11-30T00:00:00+00:00'){
							this.organization_data.onboard_date = null
						}
						this.courses = res.data.data.courses;

						this.getSubroles();
					}).catch((error) => {
						console.log(error);
					});
				}else{
					//assign courses here
					this.courses = this.provider.courses
				}
			},
			onSubmit : function(){

				this.show_form_errors = true;
				this.$validator.validateAll().then((result) => {

					if(result){
						delete this.organization_data['disciplines']

						if(typeof this.organization_data.country_code == 'object' &&  this.organization_data.country_code ){
							this.organization_data.country_code = this.organization_data.country_code.value;
						}

						if(this.organization_data.lhcsa_manager)
							this.organization_data.manager_id = this.organization_data.lhcsa_manager.id;

						if(this.organization_data.coordinator)
							this.organization_data.coordinator_id = this.organization_data.coordinator.id;

						if(this.organization_data.manager_approving_the_hha_score)
							this.organization_data.approving_id = this.organization_data.manager_approving_the_hha_score.id;

						if(this.organization_data.supporting_rn)
							this.organization_data.supporting_id = this.organization_data.supporting_rn.id;
						if(this.discipline_array.length > 0){
							this.organization_data.organization_discipline_ids = this.discipline_array.map(elem =>{ return elem.id
							})
						}else{
							this.organization_data.organization_discipline_ids = []
						}
						var params = {
							id : this.provider.id,
							filters : {
								organization_id : this.organization.id
							},
							data : this.organization_data
						}
						this.$store.dispatch('editProviderOrganizationDetail', params).then((res) => {


							this.show_form_errors = false;

						}).catch((error) => {
							console.log(error);

							this.show_form_errors = false;
						});
					}
				});
			},
			getSubroles : function(){
				return
				var params = {
					id : this.organization.id
				}

				this.$store.dispatch('getOrganizationSubroles', params).then((res) => {

					for(var i in res.data.data){
						var obj = res.data.data[i];

						switch(obj.type){
							case 'manager' :
								this.managers.push(obj);

								if(this.organization_data.lhcsa_manager == obj.id)
									this.organization_data.lhcsa_manager = obj;
								break;
							case 'supporting_rn' :
								this.supporting_rn.push(obj);

								if(this.organization_data.supporting_rn == obj.id)
									this.organization_data.supporting_rn = obj;

								break;
							case 'coordinator' :
								if(this.organization_data.coordinator == obj.id)
									this.organization_data.coordinator = obj;
									this.coordinators.push(obj);

								break;
							case 'approve_rn' :

								if(this.organization_data.manager_approving_the_hha_score  == obj.id)
									this.organization_data.manager_approving_the_hha_score = obj;

								this.approving_completions.push(obj);

								break;
						}


					}
				}).catch((error) => {
					console.log(error);
				});
			},

			getDisciplines : function(){
				var params = {
					id : this.organization.id,
					filters : {
						type : 'discipline',
					}
				}

				this.$store.dispatch('getTaxonomyValues', params).then((res) => {
					this.disciplines = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			getLocations : function(){
				var params = {
					id : this.organization.id,
					filters : {
						type : 'location'
					}
				}

				this.$store.dispatch('getTaxonomyValues', params).then((res) => {
					this.locations = res.data.data;
					this.locations_loaded = true
				}).catch((error) => {
					console.log(error);
				});
			},

			toggleCourseStatus : function(course){

				var method = 'addProviderToCourse';
				var params = {
					organization_id : this.organization.id,
					provider_id : this.provider.id,
					id : course.id,
				}
				if(course.is_active){
					//deactivate provider
					method = 'deactiveProviderFromProgram';
					// method = 'deleteProviderFromCourse';
				}
				this.$store.dispatch(method, params).then((res) => {
					course.is_active = !course.is_active;
				}).catch((error) => {
					console.log(error);
				});

			},
			simulateCompletion(course) {
				const params = {
					program_id: course.id,
					provider_id: this.provider.id,
				};

				this.$store.dispatch('simulateProgramCompletion', params).then((res) => {
						this.$snotify.success('Program simulated successfully.', {
							timeout: 2000,
							showProgressBar: true,
							closeOnClick: false,
							pauseOnHover: true
						});
					}).catch((error) => {
						console.log(error);
						this.$snotify.error('Program simulation failed.', {
							timeout: 2000,
							showProgressBar: true,
							closeOnClick: false,
							pauseOnHover: true
						});
					});
			},
			// getCountries : function(){
			// 	this.$store.dispatch('getCountries', {}).then((res) => {
			// 		this.country_codes = res.data.data;
			// 	}).catch((error) =>{
			// 		console.log(error);
			// 	});
			// }
		}
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/ProviderOrganizationDetailComponent.vue